// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import "babel-polyfill";

import "swiper/css/swiper.min.css";

import scrollReveal from "scrollreveal";
// Vue.use(scrollReveal);
Vue.prototype.$scrollReveal = scrollReveal();

console.log(scrollReveal, "scrollReveal");

//about 高德地图插件
import VueAMap from "vue-amap";
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: "your amap key",
  plugin: [
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor"
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: "1.4.4"
});

// A跳转到B，B页面停留在A页面的滚动位置；解决方法：将scrollTop设置为0
router.beforeEach((to, from, next) => {
  next();
  window.scroll(0, 0);
});

Vue.config.productionTip = false;

console.log(
  "%c 打印vue ",
  "color: #fadfa3; background: #030307; padding:5px 0;"
);
console.log(Vue.prototype);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js